// src/components/CustomerAuth/CustomerAuth.tsx
import React, { useState, useEffect } from 'react';
import CustomerLogin from './CustomerLogin';
import CustomerSignupForm from './CustomerSignupForm';
import './CustomerAuth.css';

export default function CustomerAuth() {
  const [showSignup, setShowSignup] = useState(false);
  const [isTransitioning, setIsTransitioning] = useState(false);

  useEffect(() => {
    const handleShowSignup = () => {
      setIsTransitioning(true);
      setTimeout(() => {
        setShowSignup(true);
        setIsTransitioning(false);
      }, 300);
    };

    const handleShowLogin = () => {
      setIsTransitioning(true);
      setTimeout(() => {
        setShowSignup(false);
        setIsTransitioning(false);
      }, 300);
    };

    window.addEventListener('showSignup', handleShowSignup);
    window.addEventListener('showLogin', handleShowLogin);

    return () => {
      window.removeEventListener('showSignup', handleShowSignup);
      window.removeEventListener('showLogin', handleShowLogin);
    };
  }, []);

  return (
    <div className={`auth-container ${isTransitioning ? 'transitioning' : ''}`}>
      {!showSignup ? (
        <CustomerLogin />
      ) : (
        <CustomerSignupForm />
      )}
    </div>
  );
}